import React, { Fragment, useState } from 'react';
import { ApiNote, ApiSanctionAlert } from '../api';
import { connect } from 'react-redux';
import UserEventTracker from './../tracking/userEventTracker';
import StatusModal from '../common/status/StatusModal';
import QuickStatusComments from './alert/status/QuickStatusComments';
import Has from '../auth/Has';
import { CAN_MODIFY_ALERT_THROUGH_FILTER, CAN_MODIFY_SANCTION_ALERT } from '../auth/permissions';
import RelatedAlertsStatusModal from './RelatedAlertsStatusModal';
import { AppState } from '../store/store';
import { ButtonProps } from '@salvapp/ui-components/build/button/button.types';
import { InternalApiAlertType } from '../api-internal';
import { alertStatusApi } from '../apis';

export interface SanctionNotesFormValues {
  content: string;
  sanctionAlertId: number;
}

export const ScreeningAlertStatus = ({
  alert,
  usage,
  caption,
  onComplete,
  statuses,
  activeStatuses,
  btnSize = 'medium',
}: ComponentProps) => {
  const [showModal, setShowModal] = useState(false);
  const [processRelatedAlerts, setProcessRelatedAlerts] = useState(false);
  const [note, setNote] = useState<ApiNote>();
  const [status, setStatus] = useState<string>();

  const onSubmit = async (note: ApiNote, selectedStatus: string) => {
    await alertStatusApi.updateAlertStatus({
      internalApiAlertStatusUpdate: {
        alertId: alert.id,
        alertType: InternalApiAlertType.SCREENING,
        status: selectedStatus,
        note: note.content,
      },
    });

    if (usage != null) {
      UserEventTracker.trackUserEvent('SCREENING_ALERT_STATUS_CHANGE_' + usage, {
        alertId: alert.id,
        status: selectedStatus,
      });
    }
    setNote(note);
    setStatus(selectedStatus);
    setProcessRelatedAlerts(true);
  };

  const onClose = () => {
    setShowModal(false);
  };

  const onCompleteProcessRelatedAlerts = () => {
    setProcessRelatedAlerts(false);
    onComplete && onComplete();
  };

  return (
    <Has anyPermissions={[CAN_MODIFY_SANCTION_ALERT, CAN_MODIFY_ALERT_THROUGH_FILTER]}>
      {(can: boolean) =>
        can ? (
          <Fragment>
            <QuickStatusComments
              alert={alert}
              onSubmit={onSubmit}
              showModal={setShowModal}
              caption={caption}
              withIcon={!!caption}
              btnSize={btnSize}
            />
            <StatusModal
              showModal={showModal}
              onSubmit={onSubmit}
              onClose={onClose}
              alertType={InternalApiAlertType.SCREENING}
              currentStatus={alert.status}
              alert={alert}
            />
            {processRelatedAlerts && note && status && (
              <RelatedAlertsStatusModal
                sanctionAlertId={alert.id}
                note={note.content}
                status={activeStatuses.find((it) => it.code === status)!}
                onComplete={onCompleteProcessRelatedAlerts}
              />
            )}
          </Fragment>
        ) : (
          <div>
            <span>{statuses.find((it) => it.id == alert.statusId)?.textName}</span>
          </div>
        )
      }
    </Has>
  );
};

interface Props {
  alert: ApiSanctionAlert;
  usage?: string;
  caption?: string;
  onComplete?: () => void;
  btnSize?: ButtonProps['size'];
}

const mapStateToProps = (state: AppState) => ({
  statuses: state.screeningAlertStatuses.statuses,
  activeStatuses: state.screeningAlertStatuses.statuses,
});

type ComponentProps = ReturnType<typeof mapStateToProps> & Props;

export default connect(mapStateToProps)(ScreeningAlertStatus);
